export enum TemplateType {
    All = 0,
    AutoReply = 1,
    Signature = 2,
    Answer = 3,
    AIPrompt = 4,
    Operator = 5,
    AIAssistantResponse = 6,
    AIAgentSystemPrompt = 7
}

export interface TemplateDto {
    id: string;
    name: string;
    body: string;   
    type: TemplateType;
}

export interface QueueTemplateDto {
    id: string;
    templateName: string;
    templateId: string;
    isDefault: boolean;
    templateType: TemplateType;
}